/* eslint-disable no-unused-vars */
import styled, { css } from 'styled-components';
import { Palette } from 'config';

export const BtnBox = styled.div`
  display: ${({ isShow }) => (isShow ? 'block' : 'none')};
  position: relative;
`;

export const ContentBox = styled.div`
  display: flex;
  height: auto;
  max-height: 450px;
  overflow-y: auto;
  ::-webkit-scrollbar {
    width: 6px;
  }

  ::-webkit-scrollbar-thumb {
    background-color: #cbd5e1;
    border-radius: 8px;
  }
`;
